import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { marketNewsModel } from './marketNews.model';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { GotxKeyValueListComponent } from '../../../gotx/components/gotx-key-value-list/gotx-key-value-list.component';

const customCss: string = '';

@Component({
    selector: 'app-marketNews',
    templateUrl: './marketNews.component.html'
})
export class marketNewsComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('tableHigh', { static: false }) tableHigh: GotxKeyValueListComponent;
    @ViewChild('tableMedium', { static: false }) tableMedium: GotxKeyValueListComponent;
    @ViewChild('tableLow', { static: false }) tableLow: GotxKeyValueListComponent;
    skeletonContentLoaded = false;
    keyValueListHigh:any[] = [];
    keyValueListMedium:any[] = [];
    keyValueListLow:any[] = [];
    NewsList:any[] = [];
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.FieldId_1_revalidate(),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new marketNewsModel();
        this.componentCode = 'marketNews';
        this.initHTabGroup('FieldId_1', ['tabHigh', 'tabMedium', 'tabLow',], 'tabHigh', 1);
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.openHTab('FieldId_1', 'tabHigh');
        this.setDependencies();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'marketNews';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        return this.additionalInfo;
    }
    getFieldValue() {
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.value = new marketNewsModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'marketNews'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'marketNews_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
        this.tabHigh_tabClick();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('marketNews_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.onFormLoad();
            this.checkForHTabOverFlow();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new marketNewsModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    async tabHigh_revalidate(): Promise<number> {
        var totalErrors = 0;
        await Promise.all([
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.hTabGroups['FieldId_1'].tabs['tabHigh'].errorCount = totalErrors;
        return totalErrors;
    }
    async newsRequest(newsPriority) {
        let inputMap = new Map();
        // var res = {"respCode":"0","errMsg":"","response":{"exchangenewslist":[{"priority":3,"subject":"Test News 3","timestamp":"101552","source":"CSE","fullnews":"Test News 3"},{"priority":2,"subject":"Test News 2","timestamp":"101516","source":"CSE","fullnews":"Test News 2"},{"priority":1,"subject":"Test News 1","timestamp":"101508","source":"CSE","fullnews":"Test News 1"}],"allnews":"allnews"},"sessionResponse":null,"target":"success"};
        // this.NewsList = res['response'].exchangenewslist;
           var errorCount: number = await this.revalidate();
           document.getElementById('errMsgDiv').innerHTML ="";
        if (errorCount == 0) {
            inputMap.clear();
            var priority: any = newsPriority;
            inputMap.set('Body.priority', priority);
            this.services.http.fetchApi('/market/news', 'POST', inputMap).subscribe(
                async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                    var respCode: any = res['respCode'];
                    if (respCode != null && respCode == 0) {
                    
                    this.NewsList = res['response'].exchangenewslist;
                    }
                    else {
                        //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
			//commented by Shanmuga Priya - VAPT
			const rawMsg = res['errMsg'];
			const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
			(document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
                    }
                },
                async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                    }                    
                    document.getElementById('errMsgDiv').innerHTML =this.transalte('ErrorCodes.SystemDown');
                }
            );
        } 
    }
    async tabHigh_tabClick() {
        this.newsRequest(1);
    }
    async tabMedium_revalidate(): Promise<number> {
        var totalErrors = 0;
        await Promise.all([
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.hTabGroups['FieldId_1'].tabs['tabMedium'].errorCount = totalErrors;
        return totalErrors;
    }
    async tabMedium_tabClick() {
        this.newsRequest(2);
    }
    async tabLow_revalidate(): Promise<number> {
        var totalErrors = 0;
        await Promise.all([
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.hTabGroups['FieldId_1'].tabs['tabLow'].errorCount = totalErrors;
        return totalErrors;
    }
    async tabLow_tabClick() {
        this.newsRequest(3);
    }
    async FieldId_1_revalidate(): Promise<number> {
        var totalErrors = 0;
        await Promise.all([
            this.tabHigh_revalidate(),
            this.tabMedium_revalidate(),
            this.tabLow_revalidate(),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        return totalErrors;
    }
    transalte(text) {
        return this.services.translate.instant(text);
      }
    fieldDependencies = {
    }

}
